import { createContext } from 'react';
/**
 * Data Context for Chatbot
 * @public
 */
export const ChatbotDataContext = createContext({});